import { Button } from 'core/components/ui/Button';
import { Result } from 'core/components/ui/Result';
import styled from 'styled-components';

import { BACK_HOME, SUBTITLE_CODE_404 } from './literals';

const S = {
  Page: styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};

export function NotFoundErrorPage(): JSX.Element {
  return (
    <S.Page>
      <Result
        extra={<Button href="/">{BACK_HOME}</Button>}
        status="404"
        subTitle={SUBTITLE_CODE_404}
        title="404"
      />
    </S.Page>
  );
}
